// src/checkout/CheckoutContext.jsx
import React, { createContext, useContext, useMemo, useState } from "react";

const CheckoutCtx = createContext(null);

export function CheckoutProvider({ children }) {
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: "一般清潔電潔水業務用噴瓶",
      desc: "洗面乳 480ml",
      price: 1400, // 稅前
      qty: 1,
      img: "/img/productExample.png",
    },
    {
      id: 2,
      name: "Airblade 水龍頭式乾手機",
      desc: "水龍頭尺寸 \nAB09 高度159mm  寬度297mm  深度286mm \n洗手、乾手 於洗手台原地完成 \n水不會滴落地板 \n12秒快速乾燥 \nHEPA濾網能捕捉99.9%細菌大小的微粒 \n通過NSF測試與認可 \n通過HACCP國際認可,可用於食品業 \n低碳排放 \n節省空間",
      price: 1350,
      qty: 1,
      img: "/img/productExample2.png",
    },
  ]);

  const [address, setAddress] = useState({
    receiver: "",
    phone: "",
    city: "",
    zip: "",
    street: "",
  });

  const [payment, setPayment] = useState({
    method: "card",
    cardLast4: "",
    note: "",
  });

  const value = useMemo(
    () => ({
      cartItems, setCartItems,
      address, setAddress,
      payment, setPayment,
    }),
    [cartItems, address, payment]
  );

  return <CheckoutCtx.Provider value={value}>{children}</CheckoutCtx.Provider>;
}

export const useCheckout = () => {
  const ctx = useContext(CheckoutCtx);
  if (!ctx) throw new Error("useCheckout must be used inside <CheckoutProvider>");
  return ctx;
};
